// extracted by mini-css-extract-plugin
module.exports = {"container":"container--AutomationLayout-Layouts-components__6XAXZ"};